import { render, staticRenderFns } from "./correction-process.vue?vue&type=template&id=29f9a0fa"
import script from "./correction-process.vue?vue&type=script&lang=js"
export * from "./correction-process.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports